import { render, staticRenderFns } from "./LayListChineseCulture.vue?vue&type=template&id=354a9e7e&scoped=true&"
import script from "./LayListChineseCulture.vue?vue&type=script&lang=js&"
export * from "./LayListChineseCulture.vue?vue&type=script&lang=js&"
import style0 from "./LayListChineseCulture.vue?vue&type=style&index=0&id=354a9e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a9e7e",
  null
  
)

export default component.exports